export default __webpack_public_path__ + "static/img62h-4890f6fac4c5f29ec5c3437fa83c8540.jpg";